/**
 * HomeRouter — picks the right dashboard for the current mode.
 * Mirrors the mode-switch in Flutter `home_page.dart`. Phase 1 ships only
 * the Sender dashboard; the others fall back to a placeholder until Phase
 * 2/3/5/6 land.
 */
import { useTranslation } from 'react-i18next';
import { useModeStore } from '@/stores/modeStore';
import { AppLayout } from '@/components/layout/AppLayout';
import SenderDashboard from './SenderDashboard';
import DriverDashboard from './DriverDashboard';
import CenterDashboardPage from '@/pages/centers/CenterDashboardPage';
import CompanyDashboardPage from '@/pages/companies/CompanyDashboardPage';

export default function HomeRouter() {
  const { t } = useTranslation();
  const { mode } = useModeStore();

  if (mode === 'sender') return <SenderDashboard />;
  if (mode === 'driver') return <DriverDashboard />;
  if (mode === 'center') return <CenterDashboardPage />;
  if (mode === 'company') return <CompanyDashboardPage />;

  return (
    <AppLayout>
      <div className="bg-surface border border-border rounded-2xl p-12 text-center">
        <div className="text-2xl font-bold text-primary mb-3">
          {t('mode_coming_soon_title', 'هذا الوضع قيد البناء')}
        </div>
        <p className="text-text-secondary">
          {t(
            'mode_coming_soon_body',
            'لوحة هذا الدور تُبنى في المرحلة التالية. يمكنك الآن استخدام وضع "مرسِل".',
          )}
        </p>
      </div>
    </AppLayout>
  );
}
